import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { DropdownMenu, DropdownToggle, Modal, ModalBody } from 'reactstrap'
import { toggleResponsePacksModal_action, changeTab_action, toggleSettingsModal_action, getCategories_action } from 'store/actions'
import { ModalForm } from 'modules/app/styles'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { ReactComponent as SuccessIcon } from 'assets/images/editor-icons/success.svg'
import { ReactComponent as ExpandedOff } from 'assets/images/icons/expander_off.svg'
import { CustomButton } from 'modules/auth/styles'
import { ResponsePacks, ResponsePackToastMessage, TemplatePreview } from './styles'
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView'
import { ReactComponent as BackIcon } from 'assets/images/icons/back.svg'
import { CategoryDropdown } from 'modules/pages/styles'
import { CategoriesSelector } from 'modules/pages/components/CategoriesSelector'
import { ButtonLoader } from 'utils/storageUtils'
import { addResponsePacks_api } from 'store/apis'
import { logAmplitudeEvent } from 'utils/helpers'
import { history } from 'store/store'
import { AiOutlineLink } from 'react-icons/ai'

export const ResponsePacksModal = (props) => {
  const {
    openedResponseCategory,
    response_pack_categories,
    showResponseTemplates,
    responses: { private_categories, shared_categories }
  } = props
  const [activeCategory, set_ActiveCategory] = useState(props.response_pack_categories[0] || { admin_templates: [] })
  const [templatePreview, set_templatePreview] = useState({})
  const [openCategoryDropdownID, set_openCategoryDropdownID] = useState(null)
  const [confirmData, set_confirmData] = useState({})
  const [showConfirmModal, set_showConfirmModal] = useState(false)
  const [submitting, set_submitting] = useState(false)
  const [responseMessage, set_responseMessage] = useState(null)
  const [showCategories, set_showCategories] = useState(false)

  // Set activeCategory if previewResponseTemplate
  useEffect(() => {
    if (openedResponseCategory) {
      const i = response_pack_categories.map((c) => c.uuid).indexOf(openedResponseCategory)
      if (i !== -1) {
        set_ActiveCategory(response_pack_categories[i])
      }
    }
  }, [openedResponseCategory, response_pack_categories])

  useEffect(() => {
    if (showResponseTemplates && window.innerWidth < 576) {
      set_showCategories(true)
    }
  }, [showResponseTemplates])

  const selectCategory = async (response_cat, selectedTemplate) => {
    const _confirmData = {
      category_id: response_cat.id || null,
      category: response_cat.id ? response_cat : null,
      action_type: selectedTemplate === 'all' ? 'all' : 'single',
      selectedTemplate,
      template_id: selectedTemplate === 'all' ? null : selectedTemplate.id,
      template_category_id: selectedTemplate === 'all' ? activeCategory.id : null
    }
    set_confirmData(_confirmData)
    set_openCategoryDropdownID(null)
    if (selectedTemplate === 'all') {
      set_showConfirmModal(true)
    } else {
      onConfirmAddResponsePack(_confirmData)
    }
  }

  const onConfirmAddResponsePack = async (_confirmData) => {
    try {
      set_submitting(true)
      const data = { ..._confirmData }
      delete data.selectedTemplate
      delete data.category
      await addResponsePacks_api(data)
      if (_confirmData.action_type === 'all') {
        logAmplitudeEvent('All responses from pack', { category: activeCategory.name })
      } else {
        logAmplitudeEvent('Single response from pack', { title: _confirmData.selectedTemplate.title })
      }
      set_responseMessage({
        type: 'success',
        message: (
          <>
            <SuccessIcon />
            <span>{_confirmData.selectedTemplate === 'all' ? 'All packs' : <span className='font-weight-600'>{_confirmData.selectedTemplate.title} </span>} added to </span>
            <span className='font-weight-600 mx-1'>{_confirmData.category_id ? _confirmData.category.name : 'Private'}</span> category.
          </>
        )
      })
    } catch (error) {
      if (error) {
        if (error._errors) {
          const errors = error._errors.reduce((prevVal, newVal) => `${prevVal}<br/>${newVal}`)
          set_responseMessage({ type: 'error', message: errors })
        } else if (error.message) {
          set_responseMessage({ type: 'error', message: error.message })
        } else {
          set_responseMessage({ type: 'error', message: error })
        }
      }
    }
    set_submitting(false)
    set_showConfirmModal(false)
    setTimeout(() => {
      set_responseMessage(null)
      set_confirmData({})
    }, 3000)
  }

  const closeModal = () => {
    history.replace({ search: '' })
    props.toggleResponsePacksModal(false)
  }
  return (
    <>
      <Modal isOpen={true} size='lg' fade={false} centered toggle={() => closeModal()}>
        <ModalForm onSubmit={(e) => e.preventDefault()} autoComplete='off' style={{ overflow: 'hidden', position: 'relative' }}>
          <ModalBody className='p-0'>
            <a
              href='/'
              className='modal-close'
              onClick={(e) => {
                e.preventDefault()
                closeModal()
              }}>
              <CloseIcon />
            </a>
            <ResponsePacks>
              <div className={`categories ${showCategories ? 'active' : ''}`}>
                <div className='title'> Response Packs </div>
                <div className='category-items mt-3'>
                  {props.response_pack_categories.map((c) => (
                    <div
                      key={c.id}
                      className={`category-name ${activeCategory.id === c.id ? 'active' : ''}`}
                      onClick={() => {
                        set_ActiveCategory(c)
                        set_templatePreview({})
                        set_showCategories(false)
                      }}>
                      <span>{c.name}</span>
                      <div className='expandButton'>
                        <a
                          className='deep-link mr-2'
                          title='Copy deep link'
                          href='/'
                          onClick={(e) => {
                            e.preventDefault()
                            navigator.clipboard.writeText(`${process.env.REACT_APP_BASE_URL}?open=response-packs&packId=${c.uuid}`)
                            e.target.classList.add('copied')
                            setTimeout(() => e.target.classList.remove('copied'), 1000)
                          }}>
                          <AiOutlineLink />
                        </a>
                        <div className='count'>{c.admin_templates.length}</div>
                        <ExpandedOff />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className='templates'>
                {/* Templates List */}
                {!templatePreview.id && (
                  <>
                    <div className='d-flex align-items-center mb-3'>
                      <a
                        href='/'
                        className='d-flex d-sm-none align-items-center mr-3'
                        onClick={(e) => {
                          e.preventDefault()
                          set_showCategories(true)
                        }}>
                        <BackIcon />
                        <span className='ml-1'>Back</span>
                      </a>
                      {!!activeCategory.admin_templates.length && (
                        <CategoryDropdown
                          className='select-category-dropdown'
                          isOpen={openCategoryDropdownID === 'all'}
                          toggle={() => {
                            if (!props.isFree && !props.isOnGracePeriod && !props.is_subscribed && props.total_items_count >= props.free_items_limit) {
                              props.toggleSettingsModal(true)
                              props.changeTab('billing')
                              history.push('/')
                            } else {
                              set_openCategoryDropdownID(openCategoryDropdownID === null ? 'all' : null)
                            }
                          }}>
                          <DropdownToggle tag={CustomButton} className='btn-sm outlined shadow-none gray'>
                            Add all {activeCategory.admin_templates.length} to...
                          </DropdownToggle>
                          <DropdownMenu>
                            <CategoriesSelector
                              user={props.user}
                              selectCategory={(cat) => selectCategory(cat, 'all')}
                              preExpandedCategory={[]}
                              category={{ id: 'null' }}
                              private_categories={private_categories}
                              shared_categories={shared_categories}
                              saveCategory={props.saveCategory}
                              type='response'
                              showNewCategoryForm={false}
                              getCategories={props.getCategories}
                            />
                          </DropdownMenu>
                        </CategoryDropdown>
                      )}
                    </div>
                    <div className='template-items'>
                      {!activeCategory.admin_templates.length && <div className='p-5 text-center'>No Templates Found</div>}
                      {activeCategory.admin_templates.map((t) => (
                        <div key={t.id} className={`template`} onClick={() => set_templatePreview(t)}>
                          <div className='response-title'>{t.title}</div>
                          <div className='response-content'>
                            <FroalaEditorView model={t.content} />
                          </div>
                          <CategoryDropdown
                            className={`select-category-dropdown ${openCategoryDropdownID === t.id ? 'd-block' : ''}`}
                            isOpen={openCategoryDropdownID === t.id}
                            toggle={(e) => {
                              if (!props.isFree && !props.isOnGracePeriod && !props.is_subscribed && props.total_items_count >= props.free_items_limit) {
                                props.toggleSettingsModal(true)
                                props.changeTab('billing')
                                history.push('/')
                              } else {
                                e.stopPropagation()
                                set_openCategoryDropdownID(openCategoryDropdownID === null ? t.id : null)
                              }
                            }}>
                            <DropdownToggle tag={CustomButton} className='black px-3 btn-sm' style={{ width: 90 }}>
                              Add To...
                            </DropdownToggle>
                            <DropdownMenu right>
                              <CategoriesSelector
                                user={props.user}
                                selectCategory={(cat) => selectCategory(cat, t)}
                                preExpandedCategory={[]}
                                category={{ id: 'null' }}
                                private_categories={private_categories}
                                shared_categories={shared_categories}
                                saveCategory={props.saveCategory}
                                type='response'
                                showNewCategoryForm={false}
                                getCategories={props.getCategories}
                              />
                            </DropdownMenu>
                          </CategoryDropdown>
                        </div>
                      ))}
                    </div>
                  </>
                )}

                {/* Template Preview */}
                {templatePreview.id && (
                  <TemplatePreview>
                    <a
                      href='/'
                      className='d-flex align-items-center'
                      onClick={(e) => {
                        e.preventDefault()
                        set_templatePreview({})
                      }}>
                      <BackIcon />
                      <span className='ml-1'>Back</span>
                    </a>
                    <div className='d-flex mt-2 align-items-center justify-content-between'>
                      <div className='response-title'>
                        <span>{templatePreview.title}</span>
                      </div>

                      <CategoryDropdown
                        className={`select-category-dropdown ${openCategoryDropdownID === templatePreview.id ? 'd-block' : ''}`}
                        isOpen={openCategoryDropdownID === templatePreview.id}
                        toggle={(e) => {
                          if (!props.isFree && !props.isOnGracePeriod && !props.is_subscribed && props.total_items_count >= props.free_items_limit) {
                            props.toggleSettingsModal(true)
                            props.changeTab('billing')
                            history.push('/')
                          } else {
                            e.stopPropagation()
                            set_openCategoryDropdownID(openCategoryDropdownID === null ? templatePreview.id : null)
                          }
                        }}>
                        <DropdownToggle tag={CustomButton} className='black px-3' style={{ width: 90 }}>
                          Add To...
                        </DropdownToggle>
                        <DropdownMenu right>
                          <CategoriesSelector
                            user={props.user}
                            selectCategory={(cat) => selectCategory(cat, templatePreview)}
                            preExpandedCategory={[]}
                            category={{ id: 'null' }}
                            private_categories={private_categories}
                            shared_categories={shared_categories}
                            saveCategory={props.saveCategory}
                            type='response'
                            showNewCategoryForm={false}
                            getCategories={props.getCategories}
                          />
                        </DropdownMenu>
                      </CategoryDropdown>
                    </div>
                    <div className='mt-2'>
                      <FroalaEditorView model={templatePreview.content} />
                    </div>
                  </TemplatePreview>
                )}
              </div>
            </ResponsePacks>
          </ModalBody>
          <ResponsePackToastMessage className={`${responseMessage ? `${responseMessage.type} active` : ''} `}> {responseMessage && responseMessage.message} </ResponsePackToastMessage>
        </ModalForm>
      </Modal>

      {showConfirmModal && (
        <Modal centered fade={false} size='sm' isOpen={true} toggle={() => set_showConfirmModal(false)}>
          <ModalBody className='pt-5 pb-4'>
            <div className='text-center'>
              Are you sure you want to add {confirmData.selectedTemplate === 'all' ? 'all packs' : <span className='font-weight-600'>{confirmData.selectedTemplate.title} </span>} to{' '}
              <span className='font-weight-600'>{confirmData.category_id ? confirmData.category.name : 'Private'}</span> category?
            </div>
            <div className='mt-4 d-flex justify-content-center align-items-center'>
              <CustomButton onClick={() => onConfirmAddResponsePack(confirmData)} className='btn-sm black mx-3' disabled={submitting}>
                Yes, Confirm
                {submitting && <ButtonLoader />}
              </CustomButton>
              <a
                href='/'
                className='mx-3 text-dark'
                onClick={(e) => {
                  e.preventDefault()
                  set_showConfirmModal(false)
                }}>
                Cancel
              </a>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  location: state.router.location,
  user: state.auth.user,
  response_pack_categories: state.templates.admin_template_categories.filter((c) => c.type === 'response'),
  responses: state.contents.responses,
  showResponseTemplates: state.templates.showResponseTemplates,
  openedResponseCategory: state.templates.openedResponseCategory,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  isFree: state.company.company.isFree,
  is_subscribed: state.subscription.is_subscribed,
  free_items_limit: state.company.company.free_items_limit,
  total_items_count: state.app.total_items_count
})

const mapDispatchToProps = (dispatch) => ({
  toggleResponsePacksModal: (data) => dispatch(toggleResponsePacksModal_action(data)),
  toggleSettingsModal: (status) => dispatch(toggleSettingsModal_action(status)),
  getCategories: () => dispatch(getCategories_action()),
  changeTab: (value) => dispatch(changeTab_action(value))
})

export default connect(mapStateToProps, mapDispatchToProps)(ResponsePacksModal)
